<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">

        <Input clearable placeholder="输入关键字搜索" class="search-input" v-model="keyword" />

        <label class="search-label">状态</label>
        <Select v-model="status" class="search-input" clearable>
          <Option v-for="item in statusIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">工作类型</label>
        <Select v-model="work_type_id" class="search-input" clearable filterable>
          <Option v-for="item in workTypeIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">平台</label>
        <Select v-model="live_id" class="search-input" @on-change="liveChange" clearable filterable>
          <Option v-for="item in liveIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">视频分类</label>
        <Select v-model="video_classify_id" class="search-input" @on-change="videoClassifyChange" clearable filterable>
          <Option v-for="item in videoClassifyIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">发布账号</label>
        <Select v-model="user_id" class="search-input" clearable filterable>
          <Option v-for="item in userIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        
        <label class="search-label">系列</label>
        <Select v-model="video_series_id" class="search-input" clearable filterable>
          <Option v-for="item in seriesIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <RadioGroup v-model="sort_push_date" type="button" @on-change="sort_status_change" style="margin-left: 10px;">
          <Radio label="最新上传"></Radio>
          <Radio label="最新发布"></Radio>
        </RadioGroup>

        <Button @click="handleButtonSearch" class="search-btn" type="primary" style="margin-left: 10px;">搜索</Button>
        <Button @click="showAddModal" type="primary" style="margin-left: 20px;">添加任务</Button>
        <Button @click="showAddKeywordModal" type="primary" style="margin-left: 20px;">添加关键字任务</Button>
        <Button @click="showKeywordListModal" type="primary" style="margin-left: 20px;">关键字任务列表</Button>
        <Button @click="showSeriesListModal" type="primary" style="margin-left: 20px;">添加系列视频</Button>
        </Col>
      </Row>
      <tables editable :columns="columns" v-model="tableData" :loading="tableLoading" />
      <Row class="page-con">
        <div class="page-bottom">
          <Page :current="page" :total="total" :page-size="pageSize" :page-size-opts="[10, 20, 30, 40, 100]" show-sizer
            show-elevator @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </Row>
    </Card>
    
    <Modal :width="900" :mask-closable="false" v-model="addModal" title="创建短视频任务" footer-hide>
      <forms :resetFlag="resetFlag" ref="addShortVideoTask" @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>

    <Modal :width="900" :mask-closable="false" v-model="addKeywordModal" title="添加关键字" footer-hide>
      <keywordForms :resetFlag="resetFlag" ref="addKeyword" @on-ok="addKeywordSubmit" @on-cancel="cancel" />
    </Modal>

    <Modal :width="1200" :mask-closable="false" v-model="keywordListModal" title="关键字列表" footer-hide>
      <keywordListForms :resetFlag="resetFlag" ref="keywordList" />
    </Modal>

    <Modal :width="900" :mask-closable="false" v-model="editModal" title="编辑短视频任务" footer-hide>
      <forms :resetFlag="resetFlag" ref="editShortVideoTask" @on-ok="editSumit" @on-cancel="cancel" />
    </Modal>

    <Modal :mask-closable="false" v-model="detailModal" title="短视频任务详情" footer-hide>
      <Forms_detail :resetFlag="resetFlag" ref="shortVideoTaskDetail" />
    </Modal>

    <Modal :mask-closable="false" v-model="addSeriesVideoModal" title="添加系列视频" footer-hide>
      <addSeriesVideoForms :resetFlag="resetFlag" @on-ok="seriesVideoeditSumit" ref="addSeriesVideoForms" />
    </Modal>

  </div>
</template>

<script>
import Forms from "./add_short_video_form.vue";
import keywordForms from "./add_keyword_form.vue";
import keywordListForms from "./keyword_list_form.vue";
import addSeriesVideoForms from "./add_series_video_forms.vue";
import Forms_detail from "./short_video_detail_form.vue";
import Tables from "_c/tables/table-only.vue";
import { getTimeDifference} from "@/api/uploadOss";
import {
  getShortVideoTaskList, addShortVideoTask, getShortVideoWorkTypeList,
  getShortVideoClassify, getLiveType, getStrategyUser, deleteShortVideo,
  confirmShortVideoTask, editShortVideoTask, passShortVideo, endShortVideo,
  getAdvertisementType, resetShortVideo, getClassifys, audioModelList, mouth_library_list, 
  music_library_classify, add_search_keyword,hashtag_list, video_series_list, add_video_series_list
} from "@/api/data";

import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

export default {
  name: "finance",
  components: {
    Tables,
    Forms,
    Forms_detail,
    keywordForms,
    keywordListForms,
    addSeriesVideoForms
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addWxChat: false,
      addModal: false,
      editModal: false,
      resetFlag: false,
      detailModal: false,
      editModal: false,
      editData: {},
      tableLoading: true,
      editMaxCount: false,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      addKeywordModal:false,
      keywordListModal:false,
      addSeriesVideoModal:false,
      addLinkModal:false,
      wxContacts: [],
      statusIds: [{ id: 0, name: "待确认" }, { id: 1, name: "已确认" }, { id: 2, name: "等待下载" }, { id: 6, name: "下载中" }, { id: 7, name: "下载完成" }, { id: 5, name: "任务终止" }],
      live: "",
      user: '',
      userIds: [],
      video_series_id:'',
      user_id: '',
      keyword: '',
      seriesIds: [],
      liveIds: [],
      workTypeIds: [],
      videoClassifyIds: [],
      live_id: '',
      work_type_id: '',
      video_classify_id: '',
      status: -1,
      x: 1,
      sort_push_date:'最新上传',
      columns: [
        { title: 'id', width: 100, align: "center", key: "id" },
        {
          title: "自动化",
          key: "status",
          width: 80, align: "center",
          render: (h, params) => {
            var texts = "手动"
            if (params.row.auto) {
              texts = "自动"
            }
            return h(
              "div",
              {
                props: {},
                style: {
                  color: params.row.auto ? "#ff0000" : "#515a6e"
                }
              },
              texts
            );
          },
        },
        { title: "创建人", key: "username", editable: true, align: "center" },
        {
          title: "执行人", key: "nickname", editable: true, align: "center",
          render: (h, params) => {
            var texts = ""
            var list = params.row.list
            if (list.length != 0) {
              for (var i = 0; i < list.length; i++) {
                texts += list[i].username+ "\n"
              }
            }
            return h(
              "pre",
              texts
            );
          }
        },
        { title: "工作类型", key: "work_type_name", editable: true, align: "center" },
        { title: "分类", key: "video_classify", editable: true, align: "center" },
        { title: "关键字", key: "keyword", editable: true, align: "center" },
        { title: "标题" , key: "", editable: true, align: "center",
        render: (h, params) => {
              return h('div', [
              // 显示的位置上方
                h('Tooltip', {
                  props: { placement: 'top' ,transfer: true}
                }, [
                  h('span', {
                    style: {
                      display: 'inline-block',
                      width: '70px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }, params.row.video_title),
                  // 显示的内容
                  h('span', {
                    slot: 'content',
                    style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                  },params.row.video_title)
                ])
              ])
            }},

        {
          title: "对标账号", key: "url", editable: true, align: "center",
          render: (h, params) => {
            var name = params.row.su_username
            return params.row.su_home_url != '' ? h('a', {
              attrs: {
                href: params.row.su_home_url,
                target: '_blank'
              }
            }, name): h('span', '');
          },
        },
        {
          title: "原视频详情", key: "url", editable: true, align: "center",
          render: (h, params) => {
            return params.row.video_url != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(params.row.video_url);
                    },
                  },
                },
                "查看"
              )
            ]) : h('span', '');
          },
        },
        {
          title: "视频下载地址", key: "url", editable: true, align: "center",
          render: (h, params) => {
            return params.row.url != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(baseUrl == 'https://in.sinano-ai.com/api' ? params.row.id_url : params.row.url);
                    },
                  },
                },
                "下载"
              )
            ]) : h('span', '');
          },
        },
        {
          title: "状态",
          key: "status",
          width: 100, align: "center",
          render: (h, params) => {
            var texts = "已确认"
           if (params.row.status == 0) {
              texts = "待确认"
            } else if (params.row.status == 5) {
              texts = "任务终止"
            } else if (params.row.status == 6) {
              texts = "下载中"
            }else if (params.row.status == 7) {
              texts = "下载完成"
            }else if (params.row.status == 3) {
              texts = "下载失败"
            }else if (params.row.status == 2) {
              texts = "等待下载"
            }

            var color = '#515a6e'
            if (params.row.status == 5 || params.row.status == 3){
              color = "#ff0000"
            }else if (params.row.status == 1){
              color = "#03A9F4"
            }

            return h(
              "div",
              {
                props: {},
                style: {
                  color:color
                }
              },
              texts
            );
          },
        },
        { title: "创建时间", key: "create_time", editable: true, align: "center" ,render: (h, params) => {
            let texts = getTimeDifference(params.row.create_time)
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }},
          { title: "作者发布时间", key: "create_time", editable: true, align: "center" ,render: (h, params) => {
            let texts = getTimeDifference(params.row.author_push_time)
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }},
        {
          title: "操作",
          key: "handle", align: "center",
          render: (h, params) => {
            var list = params.row.list?params.row.list:[]
            var short_video_work_type_id = params.row.short_video_work_type_id
            var status = params.row.status != 1 && params.row.status != 5 && list.length > 0 && short_video_work_type_id != 0
            var link = params.row.link
            var status1 = true
            if (link){
              status1 = params.row.url.length > 0
            }
            
            return h("div", [
            status && status1 ? h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.confirm(params);
                    },
                  },
                },
                "确认"
              ) : h('span', ''),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.edit(params);
                    },
                  },
                },
                "编辑"
              ),
              params.row.status == 5 ? h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleReset(params);
                    },
                  },
                },
                "恢复"
              ) : h('span', ''),
              params.row.status != 5 ? h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleEnd(params);
                    },
                  },
                },
                "终止"
              ) : h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.deleteTask(params);
                    },
                  },
                },
                "删除"
              )
              // params.row.status == 0 && params.row.status != 5?h(
              //   "Button",
              //   {
              //     props: {
              //       type: "error",
              //       size: "small"
              //     },
              //     style: {
              //       marginRight: "5px",
              //     },
              //     on: {
              //       click: () => {
              //         this.handlePass(params);
              //       },
              //     },
              //   },
              //   "废弃"
              // ):h('span', ''),
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "error",
              //       size: "small"
              //     },
              //     style: {
              //       marginRight: "5px",
              //     },
              //     on: {
              //       click: () => {
              //         this.handleDelete(params);
              //       },
              //     },
              //   },
              //   "删除"
              // )
            ]);
          },
        }
      ],
      tableData: [],
    };
  }, watch: {
    '$route': function (to, from) {
      // 路由发生变化时，重新获取数据
      this.handleSearch();
    }
  },
  methods: {
    sort_status_change(){
      this.handleSearch()
    },
    confirm(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认该任务？</p>',
        onOk: () => {
          confirmShortVideoTask(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    detail(params) {
      this.detailModal = true
      this.$refs.shortVideoTaskDetail.setDetail(params.row)
    },
    deleteTask(params){
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除任务？</p>',
        onOk: () => {
          deleteShortVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });

    },
    download(url) {
      window.open(url, '_blank');
    },
    edit(params) {
      this.editModal = true;
      // this.resetFlag = !this.resetFlag;
      getShortVideoWorkTypeList().then((res) => {
        var workType = res.data.data.records;
        this.$refs.editShortVideoTask.setWorkType(workType);
      });

      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.editShortVideoTask.setLiveType(liveTypes);
      });

      getShortVideoClassify().then((res) => {
        var workType = res.data.data.records;
        this.$refs.editShortVideoTask.setVideoClassify(workType);
      });

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.editShortVideoTask.setClassifyData(classifyIds);
      });

      audioModelList().then((res) => {
        var audioModelList = res.data.data.records;
        this.$refs.editShortVideoTask.setAudio(audioModelList);
      });
      
      music_library_classify().then((res) => {
        var musicLibraryClassifyList = res.data.data.records;
        this.$refs.editShortVideoTask.setMusicLibraryClassify(musicLibraryClassifyList);
      });

      hashtag_list().then((res) => {
        var hashtagList = res.data.data.records;
        this.$refs.editShortVideoTask.setHashtagList(hashtagList);
      });

      this.$refs.editShortVideoTask.setEditData(params.row);
    },
    showAddLinkModal(){
      this.addLinkModal = true;
      this.resetFlag = !this.resetFlag;
      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addLink.setClassifyData(classifyIds);
      });
    },
    showSeriesListModal(){
      this.addSeriesVideoModal = true
      this.resetFlag = !this.resetFlag;
      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addSeriesVideoForms.setClassifyData(classifyIds);
      });

      video_series_list().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addSeriesVideoForms.setSeries(classifyIds);
      });

      //addSeriesVideoForms
    },
    showKeywordListModal(){
      this.keywordListModal = true
      this.$refs.keywordList.setData();
    },
    showAddKeywordModal(){
      this.addKeywordModal = true;
      this.resetFlag = !this.resetFlag;

      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.addKeyword.setLiveType(liveTypes);
      });

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addKeyword.setClassifyData(classifyIds);
      });

    },
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;

      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.addShortVideoTask.setLiveType(liveTypes);
      });

      getShortVideoWorkTypeList().then((res) => {
        var workType = res.data.data.records;
        this.$refs.addShortVideoTask.setWorkType(workType);
      });

      getShortVideoClassify().then((res) => {
        var workType = res.data.data.records;
        this.$refs.addShortVideoTask.setVideoClassify(workType);
      });

      getAdvertisementType().then((res) => {
        var workType = res.data.data.records;
        this.$refs.addShortVideoTask.setAdvertisementType(workType);
      });

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addShortVideoTask.setClassifyData(classifyIds);
      });

      audioModelList().then((res) => {
        var audioModelList = res.data.data.records;
        this.$refs.addShortVideoTask.setAudio(audioModelList);
      });

      mouth_library_list().then((res) => {
        var mouthLibraryList = res.data.data.records;
        this.$refs.addShortVideoTask.setMouthLibrary(mouthLibraryList);
      });

      hashtag_list().then((res) => {
        var hashtagList = res.data.data.records;
        this.$refs.addShortVideoTask.setHashtagList(hashtagList);
      });

      music_library_classify().then((res) => {
        var musicLibraryClassifyList = res.data.data.records;
        this.$refs.addShortVideoTask.setMusicLibraryClassify(musicLibraryClassifyList);
      });

    },
    seriesVideoeditSumit(formValidate){
      const data = {
        video_series_id: formValidate.seriesId,
        path_list: formValidate.path_array
      }
      add_video_series_list(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addSeriesVideoModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    },
    editSumit(formValidate) {

      if (formValidate.video_url) {
        const chineseRegex = /[\u3400-\u4DBF\u20000-\u2A6DF\u2A700-\u2B73F]/;
        var hasChinese = chineseRegex.test(formValidate.video_url);

        if (!hasChinese) {
          this.$Message.success("链接链接包含中文字符串!");
          return
        }
      }

      var srt_status = false
      if (formValidate.srt_status == '需要') {
        srt_status = true
      }

      var rid_subtitles = false
      if (formValidate.rid_subtitles == '需要') {
        rid_subtitles = true
      }

      var covert_face = false
      if (formValidate.covert_face == '需要') {
        covert_face = true
      }

      if (!formValidate.url){
        covert_face = false
        srt_status = false
      }

      var covert_mouth = false
      if (formValidate.covert_mouth == '需要') {
        covert_mouth = true
      }

      var upload_id = false
      if (formValidate.upload_id == '需要') {
        upload_id = true
      }

      var gz_status = false
      if (formValidate.gz == '需要') {
        gz_status = true
      }

      var auto = false
      if (formValidate.auto == '是') {
        auto = true
      }

      var link = false
      if (formValidate.isLink == '是') {
        link = true
      }

      var music_id = formValidate.music_id
      if (formValidate.bgm == '否') {
        music_id = 0
      }

      var ids = []
      for (var i = 0; i < formValidate.selectedUser.length; i++) {
        ids.push(formValidate.selectedUser[i].id)
      }

      var hj_content_list = []
      for (var i = 0; i < formValidate.select_tableData.length; i++){
        hj_content_list.push(formValidate.select_tableData[i].content)
      }

      var mouth_gpt_text = null
      if (formValidate.hot){
        var mouth_gpt_text = {point: formValidate.point, points: formValidate.points, hot:formValidate.hot, virtual_experience: formValidate.virtual_experience}
      }

      var srt_rect_location_json = null
      if (formValidate.srt_status){
        for (var i = 0; i < formValidate.srt_rect_array.length; i++){
          formValidate.srt_rect_array[i].startX = formValidate.srt_rect_array[i].startX * this.x
          formValidate.srt_rect_array[i].startY = formValidate.srt_rect_array[i].startY * this.x
          formValidate.srt_rect_array[i].endX = formValidate.srt_rect_array[i].endX * this.x
          formValidate.srt_rect_array[i].endY = formValidate.srt_rect_array[i].endY * this.x
        }
        srt_rect_location_json = formValidate.srt_rect_array.length > 0 ?JSON.stringify(formValidate.srt_rect_array): null
      }

      var rect_location_json = null
      if (formValidate.rid_subtitles){
        for (var i = 0; i < formValidate.rect_array.length; i++){
          formValidate.rect_array[i].startX = formValidate.rect_array[i].startX * this.x
          formValidate.rect_array[i].startY = formValidate.rect_array[i].startY * this.x
          formValidate.rect_array[i].endX = formValidate.rect_array[i].endX * this.x
          formValidate.rect_array[i].endY = formValidate.rect_array[i].endY * this.x
        }
        rect_location_json = formValidate.rect_array.length > 0 ?JSON.stringify(formValidate.rect_array): null
      }

      const data = {
        black_comment: formValidate.blackItems.length > 0 ?JSON.stringify(formValidate.blackItems):null,
        good_comment: formValidate.goodItems.length > 0 ?JSON.stringify(formValidate.goodItems):null,
        video_desc: formValidate.video_desc,
        video_title: formValidate.video_title,
        dy_user_id: formValidate.dy_user_id,
        short_video_work_type_id: formValidate.short_video_work_type_id,
        video_url: formValidate.video_url,
        url: formValidate.url,
        language: formValidate.language,
        title: formValidate.title,
        srt_status: srt_status,
        rid_subtitles: rid_subtitles,
        covert_face: covert_face,
        covert_mouth: covert_mouth,
        advertisement_type_id: formValidate.advertisement_type_id,
        gz_status: gz_status,
        gz_url: formValidate.gz_url,
        gz_id_url: formValidate.gz_id_url,
        face_url: formValidate.face_url,
        advertisement_url: formValidate.advertisement_url,
        advertisement_id_url: formValidate.advertisement_id_url,
        gz_library_id: formValidate.gz_library_id,
        advertisement_library_id: formValidate.advertisement_library_id,
        classify_id: formValidate.classify_id,
        dy_ids: ids,
        auto: auto,
        upload_id: upload_id,
        audio_model_id: formValidate.audio_model_id,
        subtitle_location_json: rect_location_json,
        srt_location_json: srt_rect_location_json,
        mouth_library_id: formValidate.mouth_library_id,
        music_id: music_id,
        cover_title: formValidate.cover_title,
        push_date: formValidate.push_date,
        content: formValidate.short_video_work_type_id == 4?formValidate.hj_content: formValidate.content,
        list: formValidate.select_tableData,
        seed:formValidate.en_audio_model_id,
        laugh:formValidate.laugh,
        oral:formValidate.oral,
        speed:formValidate.speed,
        advertisement_second: formValidate.advertisement_second,
        hj_content: hj_content_list.length > 1? JSON.stringify(hj_content_list): null,
        advertisement_content:formValidate.advertisement_content,
        mouth_gpt_text: mouth_gpt_text != null ?JSON.stringify(mouth_gpt_text): null,
        link:link,
        series_name: formValidate.video_type =='是'? formValidate.video_type_name: null,
        push_date_array: formValidate.push_date_array? JSON.stringify(formValidate.push_date_array):null
      };

      editShortVideoTask(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    addLinkSubmit(formValidate){
      let data = new FormData();
      data.set("classify_id", formValidate.classify_id);
      data.set("keyword", formValidate.keyword);

    },
    addKeywordSubmit(formValidate){
      let data = new FormData();
      data.set("classify_id", formValidate.classify_id);
      data.set("keyword", formValidate.keyword);
      data.set("liveIds", formValidate.liveIds);
      add_search_keyword(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addKeywordModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    },
    addSumit(formValidate) {
      const chineseRegex = /[\u3400-\u4DBF\u20000-\u2A6DF\u2A700-\u2B73F]/;

      if (formValidate.video_url) {
        var hasChinese = chineseRegex.test(formValidate.video_url);
        if (!hasChinese) {
          this.$Message.success("链接链接包含中文字符串!");
          return
        }
      }

      var srt_status = false
      if (formValidate.srt_status == '需要') {
        srt_status = true
      }

      var rid_subtitles = false
      if (formValidate.rid_subtitles == '需要') {
        rid_subtitles = true
      }

      var covert_face = false
      if (formValidate.covert_face == '需要') {
        covert_face = true
      }

      if (!formValidate.url){
        covert_face = false
        srt_status = false
      }

      var covert_mouth = false
      if (formValidate.covert_mouth == '需要') {
        covert_mouth = true
      }

      var upload_id = false
      if (formValidate.upload_id == '需要') {
        upload_id = true
      }

      var gz_status = false
      if (formValidate.gz == '需要') {
        gz_status = true
      }

      var link = false
      if (formValidate.isLink == '是') {
        link = true
      }

      var auto = false
      if (formValidate.auto == '是') {
        auto = true
      }

      var music_id = formValidate.music_id
      if (formValidate.bgm == '否') {
        music_id = 0
      }

      var ids = []
      for (var i = 0; i < formValidate.selectedUser.length; i++) {
        ids.push(formValidate.selectedUser[i].id)
      }

      var hj_content_list = []
      for (var i = 0; i < formValidate.select_tableData.length; i++){
        hj_content_list.push(formValidate.select_tableData[i].content)
      }

      var mouth_gpt_text = null
      if (formValidate.hot){
        var mouth_gpt_text = {point: formValidate.point, points: formValidate.points, hot:formValidate.hot, virtual_experience: formValidate.virtual_experience}
      }

      var srt_rect_location_json = null
      if (formValidate.srt_status){
        for (var i = 0; i < formValidate.srt_rect_array.length; i++){
          formValidate.srt_rect_array[i].startX = formValidate.srt_rect_array[i].startX * this.x
          formValidate.srt_rect_array[i].startY = formValidate.srt_rect_array[i].startY * this.x
          formValidate.srt_rect_array[i].endX = formValidate.srt_rect_array[i].endX * this.x
          formValidate.srt_rect_array[i].endY = formValidate.srt_rect_array[i].endY * this.x
        }
        srt_rect_location_json = formValidate.srt_rect_array.length > 0 ?JSON.stringify(formValidate.srt_rect_array): null
      }

      var rect_location_json = null
      if (formValidate.rid_subtitles){
        for (var i = 0; i < formValidate.rect_array.length; i++){
          formValidate.rect_array[i].startX = formValidate.rect_array[i].startX * this.x
          formValidate.rect_array[i].startY = formValidate.rect_array[i].startY * this.x
          formValidate.rect_array[i].endX = formValidate.rect_array[i].endX * this.x
          formValidate.rect_array[i].endY = formValidate.rect_array[i].endY * this.x
        }
        rect_location_json = formValidate.rect_array.length > 0 ?JSON.stringify(formValidate.rect_array): null
      }

      const data = {
        black_comment: formValidate.blackItems.length > 0 ?JSON.stringify(formValidate.blackItems):null,
        good_comment: formValidate.goodItems.length > 0 ?JSON.stringify(formValidate.goodItems):null,
        video_desc: formValidate.video_desc,
        video_title: formValidate.video_title,
        dy_user_id: formValidate.dy_user_id,
        short_video_work_type_id: formValidate.short_video_work_type_id,
        video_url: formValidate.video_url,
        url: formValidate.url,
        language: formValidate.language,
        title: formValidate.title,
        srt_status: srt_status,
        rid_subtitles: rid_subtitles,
        covert_face: covert_face,
        covert_mouth: covert_mouth,
        face_url: formValidate.face_url,
        id_url: formValidate.id_url,
        upload_id: upload_id,
        advertisement_type_id: formValidate.advertisement_type_id,
        gz_status: gz_status,
        gz_url: formValidate.gz_url,
        gz_id_url: formValidate.gz_id_url,
        advertisement_url: formValidate.advertisement_url,
        advertisement_id_url: formValidate.advertisement_id_url,
        gz_library_id: formValidate.gz_library_id,
        advertisement_library_id: formValidate.advertisement_library_id,
        dy_ids: ids,
        auto: auto,
        audio_model_id: formValidate.audio_model_id,
        subtitle_location_json: rect_location_json,
        srt_location_json: srt_rect_location_json,
        mouth_library_id: formValidate.mouth_library_id,
        music_id: music_id,
        cover_title: formValidate.cover_title,
        push_date: formValidate.push_date,
        content: formValidate.short_video_work_type_id == 4?formValidate.hj_content: formValidate.content,
        list: formValidate.select_tableData,
        seed:formValidate.en_audio_model_id,
        laugh:formValidate.laugh,
        oral:formValidate.oral,
        speed:formValidate.speed,
        advertisement_second: formValidate.advertisement_second,
        hj_content: hj_content_list.length > 1? JSON.stringify(hj_content_list): null,
        advertisement_content:formValidate.advertisement_content,
        mouth_gpt_text: mouth_gpt_text != null ?JSON.stringify(mouth_gpt_text): null,
        link:link,
        series_name: formValidate.video_type =='是'?formValidate.video_type_name: null,
        push_date_array: formValidate.push_date_array?JSON.stringify(formValidate.push_date_array):null
      };

      addShortVideoTask(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    }, videoClassifyChange(value) {
      this.getStrategyUser()

    }, liveChange(value) {
      this.getStrategyUser()

    }, getStrategyUser() {
      var params = {
        short_video_classify: this.video_classify_id,
        live_id: this.live_id
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          var user = users[i]
          data.push({ id: user.id.toString(), name: user.username })
        }
        this.userIds = data
      });

    },getSeries() {
      video_series_list().then((res) => {
        var series = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < series.length; i++) {
          var serie = series[i]
          data.push({ id: serie.id.toString(), name: serie.name })
        }
        this.seriesIds = data
      });

    },
    cancel() {
      this.showAddModal = false
    },
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleButtonSearch() {
      this.page = 1
      this.handleSearch()
    },
    handleSearch() {
      this.setTableLoading(true);
      var sort_push_date_status = this.sort_push_date == "最新上传"? false: true
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.status,
        live_id: this.live_id,
        keyword: this.keyword,
        user_id: this.user_id,
        work_type: this.work_type_id,
        video_classify: this.video_classify_id,
        sort_push_date: sort_push_date_status,
        video_series_id: this.video_series_id
      };
      getShortVideoTaskList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleReset(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认恢复任务流？</p>',
        onOk: () => {
          resetShortVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    handleEnd(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认终止任务流？</p>',
        onOk: () => {
          endShortVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    handlePass(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认废弃？</p>',
        onOk: () => {
          passShortVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    handleDelete(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          deleteShortVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.getStrategyUser()
    this.getSeries()
    this.handleSearch();
    getLiveType({}).then((res) => {
      if (res.data.code == 200) {
        var lives = res.data.data;
        var data = new Array()
        for (var i = 0; i < lives.length; i++) {
          data[i] = { id: lives[i].id.toString(), name: lives[i].name }
        }
        this.liveIds = data
      }
    });

    getShortVideoWorkTypeList().then((res) => {
      var workType = res.data.data.records;
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.workTypeIds = data
    });

    getShortVideoClassify({}).then((res) => {
      var workType = res.data.data.records;
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.videoClassifyIds = data
    });

  },
};
</script>
